// src/admin/FormEditor/utils/sanitization.js

export const sanitizeIdentifier = (value) => {
  // Remove spaces and special characters
  let sanitized = value
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9_-]/g, "_");

  return sanitized;
};
